import { faEnvelopeCircleCheck, faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { unwrapResult } from '@reduxjs/toolkit';
import ordinal from 'ordinal';
import * as React from 'react';
import { Button, Col, Collapse, FormGroup, Input, Label, Row, Spinner } from 'reactstrap';
import { useAppDispatch } from '../../hooks';
import { afrEmailStage, getEmailStageByAfrYear, saveAfrEmailStageGivenAfrYear, afrEmailStageInput, advanceAfrEmailStageGivenAfrYear, sendAutoReminderReportTypeEmail, autoReminderEmailScheduler } from '../../redux/EventsSlice';
import WYSIWYGEditor from './WYSIWYGEditor';
import { downloadDocumentById } from '../../redux/DocumentsSlice';
import { Reference, Part, getPartValue } from '../../redux/TaxonomyReferenceSlice';
import { LogicalPeriodEnum, TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { DateTime } from 'luxon';
import DatePicker from "react-datepicker";
import dateHelper from '../../utils/dateHelper';

interface groupEmailerProps {
    emailTarget: string;
    emailTypeValue: TaxonomyTypeEnum;
    afrYear: number;
    period: LogicalPeriodEnum;
    references: Reference[];
}


const GroupEmailer = (props: groupEmailerProps) => {

    const dispatch = useAppDispatch();

    const [emailerType, setEmailerType] = React.useState<TaxonomyTypeEnum>(props.emailTypeValue);

    const [subject, setSubject] = React.useState<string>('');
    const [body, setBody] = React.useState<string>('');
    const [isReadOnlyMode, setIsReadOnlyMode] = React.useState<boolean>(false);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const [emailStages, setEmailStages] = React.useState<Array<afrEmailStage>>([]);
    const [selectedIndex, setSelectedIndex] = React.useState<number>(0);
    const [selectedAfrYear, setSelectedAfrYear] = React.useState<number>(0);


    //const [scheduledDate, setScheduledDate] = React.useState<Date | null>(null);
    //const [hasScheduledDateResults, setHasScheduledDateResults] = React.useState<boolean>(false);
   
 

    const handleEmailItemClick = (indexValue: number) => {

        setSelectedIndex(indexValue);
        if (indexValue == emailStages.length - 1) {
            setIsReadOnlyMode(false);
        } else {
            setIsReadOnlyMode(true);
        }
        setSubject(emailStages[indexValue].subject);
        setBody(emailStages[indexValue].emailContent);

    }

    const handleReportLinkClick = async (reportLink: string) => {
        await dispatch(downloadDocumentById(reportLink));
    }



    const handleSaveEmailStageClick = async () => {
        setIsLoading(true);
        let updatedAfrEmailStageInput: afrEmailStageInput =
        {
            subject: subject,
            emailContent: body,
            numberContacted: emailStages[selectedIndex].numberContacted,
            order: emailStages[selectedIndex].order,
            reportLink: emailStages[selectedIndex].reportLink,
            taxonomyType: props.emailTypeValue.toString(),
            autoReminderEmailDate: emailStages[selectedIndex].autoReminderEmailDate,
            nextEmailDeliveryDate: emailStages[selectedIndex].nextEmailDeliveryDate,
            nextEmailDeliveryText: emailStages[selectedIndex].nextEmailDeliveryText
        }

        let emailStageByYear: { item1: number; item2: afrEmailStageInput } =
        {
            item1: selectedAfrYear,
            item2: updatedAfrEmailStageInput
        }

        var resultAction = await dispatch(saveAfrEmailStageGivenAfrYear(emailStageByYear));
        var originalPromiseResult: afrEmailStage | null = unwrapResult(resultAction);

        if (originalPromiseResult != null) {

            let collectiveEmailStages: Array<afrEmailStage> = [];

            for (var i = 0; i < emailStages.length; i++) {
                if (selectedIndex != i) {
                    collectiveEmailStages.push(emailStages[i]);
                } else {
                    collectiveEmailStages.push(originalPromiseResult);
                }
            }
            setEmailStages(collectiveEmailStages);
        }
        setIsLoading(false);
    }

    const handleAdvanceEmailStageClick = async () => {
        setIsLoading(true);
        let updatedAfrEmailStageInput: afrEmailStageInput =
        {
            subject: subject,
            emailContent: body,
            numberContacted: emailStages[selectedIndex].numberContacted,
            order: emailStages[selectedIndex].order,
            reportLink: emailStages[selectedIndex].reportLink,
            taxonomyType: props.emailTypeValue.toString(),
            autoReminderEmailDate: emailStages[selectedIndex].autoReminderEmailDate,
            nextEmailDeliveryDate: emailStages[selectedIndex].nextEmailDeliveryDate,
            nextEmailDeliveryText: emailStages[selectedIndex].nextEmailDeliveryText
        }

        let emailStageByYear: { item1: number; item2: afrEmailStageInput } =
        {
            item1: selectedAfrYear,
            item2: updatedAfrEmailStageInput
        }

        var resultAction = await dispatch(advanceAfrEmailStageGivenAfrYear(emailStageByYear));
        var originalPromiseResult: afrEmailStage | null = unwrapResult(resultAction);

        if (originalPromiseResult != null) {
           setEmailStageGivenReportYear(selectedAfrYear);
        }
        setIsLoading(false);
    }

    const setEmailStageGivenReportYear = async (reportYearValue: number) => {
        setIsLoading(true);
        let collectiveEmailStages: Array<afrEmailStage> = [];

        setSelectedAfrYear(reportYearValue);

        let reportYear: { item1: number, item2: string } =
        {
            item1: reportYearValue,
            item2: props.emailTypeValue.toString()
        }

        var resultAction = await dispatch(getEmailStageByAfrYear(reportYear));
        var originalPromiseResult: Array<afrEmailStage> | null = unwrapResult(resultAction);

        if (originalPromiseResult != null) {

            setSubject("");
            setBody("");

            for (var i = 0; i < originalPromiseResult.length; i++) {
                collectiveEmailStages.push(originalPromiseResult[i]);
            }
        }

        setEmailStages(collectiveEmailStages);
        
        setIsLoading(false);
    }


    const createChangeDate = function (event: any, existing: Date | null) {
        if (event && isNaN(Date.parse(event)) == false) {
            var dateString = dateHelper.formatDateToISO(event);
            if (!existing || dateString !== existing.toISOString()) {
                return new Date(dateString);
            } else {
                return existing;
            }
        } else {
            return null;
        }
    }


    //const handleScheduledDate = function (event: any) {
    //    setScheduledDate(createChangeDate(event, scheduledDate));
    //}

    //const handleAutoReminderReportTypeEmail = async () => {
    //    var convertedScheduledDate: string | null = scheduledDate ? DateTime.fromJSDate(scheduledDate).toISO().replace("Z", "-04:00") : null;
    //    var collectiveReminderEmailStages: Array<autoReminderEmailScheduler> = [];
    //    if (convertedScheduledDate != null)
    //    {
    //        let reportYear: { item1: string, item2: string } =
    //        {
    //            item1: convertedScheduledDate,
    //            item2: props.emailTypeValue.toString()
    //        }

    //        var resultAction = await dispatch(sendAutoReminderReportTypeEmail(reportYear))
    //        var originalPromiseResult: Array<autoReminderEmailScheduler> | null = unwrapResult(resultAction);;

    //        if (originalPromiseResult != null) {

    //            if (originalPromiseResult.length > 0) {
    //                setHasScheduledDateResults(true);
    //            }
    //            else {
    //                setHasScheduledDateResults(false);
    //            }
    //            for (var i = 0; i < originalPromiseResult.length; i++) {
    //                collectiveReminderEmailStages.push(originalPromiseResult[i]);
    //            }
    //        }
    //    }
    //}


    const additionalSelectionsRequired = function (): boolean {
        if (props.afrYear <= 0) {
            return true;
        }
        if (props.emailTypeValue === TaxonomyTypeEnum.COURT_REPORTING_939 && props.period === LogicalPeriodEnum.ANNUAL) {
            return true;
        }
        return false;
    }

    const getReportTitleValue = function (): string {
        var result: string = "";

        if (props.emailTypeValue != null) {

            switch (props.emailTypeValue) {
                case TaxonomyTypeEnum.AFR:
                    result = "AFR";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    result = "Court Report 29.0085";
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    result = "Court Report 939.185";
                    break;

                default:
                    result = "";
                    break;
            }
        }

        return result;
    }

    React.useEffect(() => {

        if (emailStages.length > 0) {
            handleEmailItemClick(emailStages.length - 1);
        }

    }, [emailStages])

    React.useEffect(() => {

        if (props.afrYear != null) {
            setEmailerType(props.emailTypeValue);
            
            switch (props.emailTypeValue) {
                case TaxonomyTypeEnum.AFR:
                    if (props.afrYear) {
                        if (props.afrYear > 0) {
                            setEmailStageGivenReportYear(props.afrYear);
                        }
                    }
                    break;
                case TaxonomyTypeEnum.COURT_REPORTING_939:
                    if (props.period != LogicalPeriodEnum.ANNUAL) {
                        let stringValue939: string = props.period.toString().replace("Q_", "") + "939" + props.afrYear.toString();
                        let courtReporting939Year: number = parseInt(stringValue939, 10);
                        setEmailStageGivenReportYear(courtReporting939Year);
                    }                   
                    break;

                case TaxonomyTypeEnum.COURT_REPORTING_29:
                    if(props.afrYear) {
                        if (props.afrYear > 0) {
                            let stringValue29: string = "29" + props.afrYear.toString();
                            let courtReporting29Year: number = parseInt(stringValue29, 10);
                            setEmailStageGivenReportYear(courtReporting29Year);
                        }
                    }
                    break;
                
            }
        }


    }, [props])

    const chooseAnAFRYear = (<React.Fragment>

       
     {/*<Collapse isOpen={ props.afrYear <= 0}>*/}
     {/*   <Row>*/}
     {/*       <Col>*/}
               
     {/*           <table>*/}
     {/*               <tr>*/}
     {/*               <th className="col-2 text-right">Enter Date:</th>*/}
     {/*               <td className="col-4">*/}
     {/*                   <DatePicker*/}
     {/*                       selected={scheduledDate}*/}
     {/*                       dateFormat="MM/dd/yyyy"*/}
     {/*                       onChange={handleScheduledDate}*/}
     {/*                       /> &nbsp;&nbsp;&nbsp;&nbsp;<Button type="button" onClick={(e) => handleAutoReminderReportTypeEmail()}   >Test Autoremind Email ...</Button>*/}
     {/*                  </td>*/}
     {/*               </tr>  */}
     {/*               <tr>*/}
     {/*                   <td> <h4 ><b>Results :  {hasScheduledDateResults == true ? "Please check email. " : "No results for this date."} </b></h4></td>*/}
     {/*               </tr>*/}
     {/*           </table>*/}
                
     {/*       </Col>*/}
     {/*   </Row>*/}
     {/*</Collapse>*/}

        <Row>
            <Col>
                <Row>
                    <Col>
                        <h4>Send Emails For {props.emailTarget}</h4>
                    </Col>
                </Row>
                <FormGroup className="mt-2">
                    {props.afrYear <= 0 &&
                        <Row>
                            <Col>
                                <Label><b>Select A Fiscal Year</b></Label>
                            </Col>
                        </Row>
                    }
                    {props.emailTypeValue === TaxonomyTypeEnum.COURT_REPORTING_939 && props.period === LogicalPeriodEnum.ANNUAL &&
                        <Row>
                            <Col>
                                <Label><b>Select A Quarter</b></Label>
                            </Col>
                        </Row>
                    }
                </FormGroup>
            </Col>
        </Row>
    </React.Fragment>)

    const includedLinksRender = (
        <div>
            {props.references.map(r => (
                <Row>
                    <Col>
                        <a href={getPartValue(r, "URI")} target="_blank">{getPartValue(r,"Name")}</a>
                    </Col>
                </Row>
            )) }
        </div>
    );

    const afrRenderMode = (<React.Fragment>
        <Collapse isOpen={isLoading == false}>
            <Row>
                <Col>

                    <Row>
                        <Col>
                            <h4>Send Emails For {props.emailTarget}</h4>
                        </Col>
                    </Row>


                    <FormGroup className="mt-2">
                        <Row>
                            <Col className="text-md-right" >
                                <Label>&nbsp;</Label>
                            </Col>

                            <Col md="10" >

                                <div>
                                    {emailStages.map((item: afrEmailStage, x) => (
                                        <div >
                                            <Collapse isOpen={x == emailStages.length - 1}>

                                                <Row>
                                                    <Col>
                                                        <b style={{ color: 'Blue' }}>
                                                            {item.nextEmailDeliveryDate && item.nextEmailDeliveryDate.length > 0 ?  item.nextEmailDeliveryText +  " Email Scheduled Date : " + item.nextEmailDeliveryDate : ""}
                                                        </b>
                                                    </Col>
                                                </Row>
                                            </Collapse>
                                        </div>))}
                                </div>

                            </Col>
                        </Row>

                    </FormGroup>



                    <FormGroup className="mt-2">
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Subject:</b></Label>
                            </Col>
                            <Col md="10">
                                <Input type="text" value={subject}
                                    onChange={(e) => setSubject(e.currentTarget.value)}
                                    disabled={isReadOnlyMode == true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Included Links:</b></Label>
                            </Col>
                            <Col md="10">
                                {includedLinksRender}
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Stage:</b></Label>
                            </Col>
                            <Col md="10">

                                <div style={{ display: "flex", overflowX: "auto", width: "100%" }}>
                                    {emailStages.map((item: afrEmailStage, itx) => (
                                        <div key={item.order} className={`listItem ${itx == selectedIndex ? 'selected' : ''}`}
                                            onClick={() => handleEmailItemClick(itx)}
                                            style={{ minWidth: "25%", boxSizing: "border-box", padding: "10px", textAlign: "center", border: "1px solid #ccc" }}>

                                            <Collapse isOpen={itx < emailStages.length - 1}>


                                                <Row>
                                                    <Col>
                                                        <FontAwesomeIcon 
                                                            style={{ color: "#182853" }}  />

                                                        {item.autoReminderEmailDate && item.autoReminderEmailDate.length > 0 ? "Auto Reminder Email already sent on : " + item.autoReminderEmailDate   : ""}
                                                    </Col>
                                                </Row>


                                                <Row >
                                                    <Col>
                                                        <FontAwesomeIcon 
                                                            style={{ color: "#182853" }} icon={faEnvelopeCircleCheck} />

                                                        {" " + (item.order > 0 ? ordinal(item.order) + " Email" : getReportTitleValue() + " Open Email")}

                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {item.numberContacted.toString() + " Contacted"}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {item.reportLink && item.reportLink.length > 0 ? (<div onClick={() => handleReportLinkClick(item.reportLink)}>Download Contacted Report</div>) : (<></>)}
                                                    </Col>
                                                </Row>
                                            </Collapse>

                                            <Collapse isOpen={itx == emailStages.length - 1}>
                                                <Row>
                                                    <Col>
                                                        <FontAwesomeIcon style={{ color: "#182853", width: "4em" }} icon={faEnvelopeOpenText} />
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        {"Send " + (item.order > 0 ? ordinal(item.order) + " Notification Email" : getReportTitleValue() + " Open Email")}
                                                    </Col>
                                                </Row>
                                            </Collapse>
                                        </div>))}
                                </div>

                             </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Label><b>Email:</b></Label>
                            </Col>
                            <Col md="10">

                                <WYSIWYGEditor
                                    content={body}
                                    setContent={setBody}
                                    readOnly={isReadOnlyMode == true}

                                />

                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col className="text-md-right" >
                                <Button color="primary" type="button" disabled={isReadOnlyMode == true} onClick={(e) => handleSaveEmailStageClick()}>Save</Button>
                                &nbsp;&nbsp;
                                <Button color="primary" type="button" disabled={isReadOnlyMode == true} onClick={(e) => handleAdvanceEmailStageClick()}>Send</Button>
                            </Col>
                            <Col md="10">



                            </Col>
                        </Row>
                    </FormGroup>
                </Col>
            </Row>
        </Collapse>
        <Collapse isOpen={isLoading == true}>
            <Spinner children={''} style={{ width: '1rem', height: '1rem' }}
                type="grow" color="warning"
            />
        </Collapse>

    </React.Fragment>);

    const unknownMode = (<></>);

    return (
        <React.Fragment>
            <Collapse isOpen={emailerType !== TaxonomyTypeEnum.BASE}>
                {additionalSelectionsRequired() ? chooseAnAFRYear : afrRenderMode}
            </Collapse>
            <Collapse isOpen={emailerType === TaxonomyTypeEnum.BASE}>
                {unknownMode}
            </Collapse>
        </React.Fragment>
    );

}


export default GroupEmailer;




